export default __webpack_public_path__ + "static/media/michaela_name.7c3c0b13.png";